import { InstallationPermission } from 'src/routes/Soc/User/UserHooks'
import type { UserLogin } from 'src/types'
import { apiAction, withSession } from './withSession'

/*export const login = ({email, password, code, associationRequest }: {
  email: string,
  password: string,
  associationRequest: boolean,
  code?: string
}) => {
  return apiAction({
    action: 'login',
    url: 'api/auth/login',
    body: { email, password, associationRequest, code },
  })
}*/

export const login = (payload: UserLogin) => ({ type: 'user/login', payload })

export const logout = () => ({ type: 'logout' })

export interface RegisterUser {
  firstName: string
  lastName: string
  email: string
  phone: string
  client: string
}

export const associate = (secret: string, id: string) => {
  return apiAction({
    action: 'associate',
    url: 'api/auth/validate/mfa',
    body: { secret, id }
  })
}

export const register = (user: RegisterUser) => {
  return apiAction({
    action: 'register',
    url: 'api/auth/sign-up',
    body: user
  })
}

export const recover = (email: string) => {
  return apiAction({
    action: 'recover',
    url: 'api/auth/recovery',
    body: { email }
  })
}

export const changePassword = (
  user: string | number,
  token: string,
  password: string
) => {
  return apiAction({
    action: 'recover',
    url: 'api/auth/recovery/complete',
    body: { user, token, password }
  })
}

export const getUsers = () => {
  return withSession({
    action: 'getUsers',
    url: 'api/user/users'
  })
}

export const getUser = (userId: string | number) => {
  return withSession({
    action: 'getUser',
    url: 'api/user/' + userId
  })
}

export const addUser = (
  username: string,
  email: string,
  phone: string,
  rol: string,
  userInstallation: InstallationPermission[]
) => {
  return withSession({
    action: 'addUser',
    url: 'api/user',
    body: { username, email, phone, rol, userInstallation }
  })
}

export const updateUser = (
  id: string | number,
  username: string,
  email: string,
  phone: string,
  rol: string,
  userInstallation: InstallationPermission[]
) => {
  return withSession({
    fetchOptions: { method: 'PUT' },
    action: 'updateUser',
    url: 'api/user/' + id,
    body: { username, email, phone, rol, userInstallation }
  })
}

export const getQr = () => {
  return withSession({
    action: 'getQr',
    url: 'api/user/2factor/qr'
  })
}

export const updateTwoFactorStatus = (status: boolean, code: string) => {
  return withSession({
    fetchOptions: { method: 'PUT' },
    action: 'updateTwoFactorStatus',
    url: 'api/user/2factor/update',
    body: { status, code }
  })
}

export const getMe = () => {
  return withSession({
    action: 'getMe',
    url: 'api/user/me'
  })
}
